export const VIWERSHOW = 'VIWERSHOW';
export const VIWERSCLOSE = 'VIWERSCLOSE';


